export default "__VITE_ASSET__d5f58b81__"